var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlutterwave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10994",
    "data-name": "Group 10994",
    transform: "translate(-123 -398)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_8656",
    "data-name": "Rectangle 8656",
    transform: "translate(123 398)",
    fill: "#fff",
    stroke: "rgba(112,112,112,0.25)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 41,
    rx: 4.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10999",
    "data-name": "Group 10999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10022",
    "data-name": "Path 10022",
    d: "M-114.956,216.951c10.149-1.524,3.647,7.12.5,9.551a15.728,15.728,0,0,1,5.326,6.638c1.756,4.843-2.566,5.557-5.827,4.341a18.134,18.134,0,0,1-8.8-7.081,6.665,6.665,0,0,1-1.814-.27,21.87,21.87,0,0,1,1.351,9.493c0-5.6-2.663-11.153-6.5-15.784-1.351-1.621.039-2.817,1.254-1.254a34.146,34.146,0,0,1,2.258,3.531C-125.878,221.563-119.394,217.588-114.956,216.951Zm-1.447,8.239c1.987-1.216,8.027-7.7,2.393-7.12-3.242.367-7.178,3.357-8.8,5.287A10.5,10.5,0,0,1-116.4,225.191Zm-5.6,5.036a15.316,15.316,0,0,0,6.946,4.708c1.544.405,3.242.232,2.624-1.968a12.065,12.065,0,0,0-3.84-5.152,8.361,8.361,0,0,1-1.447.849A13.969,13.969,0,0,1-122,230.227Z",
    transform: "translate(264 190.802)",
    fill: "#eba12a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10023",
    "data-name": "Path 10023",
    d: "M-93.089,258.238a7.732,7.732,0,0,1,4.477,1.486,10.615,10.615,0,0,1-3.975,1.023C-94.652,260.766-95.076,258.431-93.089,258.238Z",
    transform: "translate(234.221 157.35)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlutterwave);
export default __webpack_public_path__ + "static/media/flutterwave.dd74b02454c16ef5e9cdb08b7f0fa7dc.svg";
export { ForwardRef as ReactComponent };